import styled, { keyframes } from 'styled-components'

const breatheAnimation = keyframes`
    0% {
        color: #d7a9ff;
    }
    50% {
        color: #c786ff;
    }
    100% {
        color: #d7a9ff;
    }
`

export const DevQuickFillContainerStyle = styled.div`
    border: 0.5px solid #d5d9e0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 10px;
    min-height: 25vh;
    margin-bottom: 20px;
    background-color: steelblue;
    > button {
        align-self: center;
        width: 30vw;
        background-color: blueviolet;
    }
    > h2 {
        color: #d1a0fd;
        text-shadow: 2px 2px 0px blue;
        margin-bottom: 0px;
        animation-name: ${breatheAnimation};
        animation-duration: 2s;
        animation-iteration-count: infinite;
        animation-timing-function: step-start;
    }
    > p {
        margin: 10px 10px 20px 10px;
        color: antiquewhite;
    }
`

export const DevQuickFillTextarea = styled.textarea`
    flex-grow: 1;
    padding: 10px;
`
